export class UserGroupFilterEntity {
  id?: number
  name?: string
  searchWord?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
